<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex align-center ga-1 mb-1">
        <span class="label mb-0">
          {{ title }}
        </span>
        <v-tooltip v-if="showInfo" location="top">
          <template #activator="{ props }">
            <v-icon
              color="primary"
              icon="mdi-information-outline"
              size="small"
              v-bind="props" />
          </template>

          <span>
            <strong>{{ getInfoTitle(showInfo) }}</strong>
            <template v-if="getInfoText(showInfo)">
              — {{ getInfoText(showInfo) }}
            </template>
          </span>
        </v-tooltip>
      </div>
      <slot name="action">
        <span
          v-if="!disabled"
          class="d-inline-flex align-center ga-1 cursor-pointer"
          style="color: #185fa5; font-size: 12px; font-weight: 600"
          @click="$emit('action')">
          <v-icon :icon="!multiple ? 'mdi-pencil-outline' : 'mdi-plus'" />
          {{ actionLabel }}
        </span>
      </slot>
    </div>

    <b-section-loader :loading="loading">
      <div v-if="people.length" class="d-flex flex-column ga-2">
        <v-card
          v-for="person in people"
          :key="person.id"
          border
          class="section"
          rounded="lg">
          <div class="d-flex align-center justify-space-between ga-3">
            <div>
              <div class="font-size-13">
                {{ getPersonName(person.user || person) }}
              </div>
              <div class="font-size-11">
                {{
                  (person.user || person)?.post ||
                  (person.user || person)?.department?.name ||
                  'Підрозділ відсутній'
                }}
              </div>
            </div>
            <v-btn
              v-if="multiple"
              :disabled="disabled"
              color="error"
              density="comfortable"
              icon
              size="small"
              variant="text"
              @click="$emit('delete', person.id)">
              <v-icon size="x-small">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>
      <div v-else class="mt-3 text-grey font-italic">Дані відсутні</div>
    </b-section-loader>
  </div>
</template>

<script lang="ts">
import { getPersonName } from 'best-modules/utils/helpers'
import { BSectionLoader } from 'best-modules/components'
import { PropType } from 'vue'

interface PersonLike {
  id?: number
  name?: string | null
  surname?: string | null
  patronymic?: string | null
  photo?: string | null
  post?: string | null
  department?: { name?: string | null } | null
  user?: PersonLike | null
}

export default {
  name: 'TaskSidebarPersonSection',
  components: { BSectionLoader },
  props: {
    title: { type: String, required: true },
    actionLabel: { type: String, required: true },
    people: { type: Array as PropType<PersonLike[]>, default: () => [] },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    showInfo: { type: String },
  },
  emits: ['action', 'delete'],
  methods: {
    getPersonName,
    getInfoTitle(text: any) {
      return text.split('—')[0].trim()
    },
    getInfoText(text: any) {
      return text.split('—').slice(1).join('—').trim()
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 8px 10px;
  background: #fafbfc;
  border: 1px solid #f0f0f5;
  border-radius: 8px;
}
</style>
